export const VictoryChart = require('victory').VictoryChart;
export const VictoryLabel = require('victory').VictoryLabel;
export const VictoryAxis = require('victory').VictoryAxis;
export const VictoryLine = require('victory').VictoryLine;
export const VictoryArea = require('victory').VictoryArea;
export const VictoryGroup = require('victory').VictoryGroup;
export const VictoryScatter = require('victory').VictoryScatter;
export const VictoryBar = require('victory').VictoryBar;
export const VictoryCursorContainer = require('victory').VictoryCursorContainer;
export const VictoryTooltip = require('victory').VictoryTooltip;
export const VictoryZoomContainer = require('victory').VictoryZoomContainer;
export const VictoryClipContainer = require('victory').VictoryClipContainer;
